import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzXmas70 } from './pages'

type TIdToPageMapWoofzXmas70 = Record<PageIdWoofzXmas70, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_XMAS_70: TIdToPageMapWoofzXmas70 = {
  [PageId.SUBSCRIPTIONS_XMAS_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_70/pages/subscriptions/SubscriptionWoofzXmas70'
      ).then((m) => ({
        default: m.SubscriptionsXmas70,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_70/pages/subscriptions/SubscriptionWoofzXmas70'
      ),
  },
  [PageId.CHAT_UPSELL_XMAS_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_70/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_70/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_XMAS_70]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_xmas/woofz_xmas_70/pages/upsell/Upsell').then(
        (m) => ({
          default: m.Upsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_xmas/woofz_xmas_70/pages/upsell/Upsell'),
  },
  [PageIdWoofzXmas70.DOWNLOAD_XMAS_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_70/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_70/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzXmas70.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
